// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    isLoading$ = this.loadingSubject.asObservable();

    private requestCount = 0;

    show(): void {
        this.requestCount++;
        if (this.requestCount === 1) {
            // Only show loading spinner when first request starts
            this.loadingSubject.next(true);
        }
    }

    hide(): void {
        if (this.requestCount === 0) {
            return; // Just to be safe
        }

        this.requestCount--;

        if (this.requestCount === 0) {
            // Only hide spinner when all requests are completed
            this.loadingSubject.next(false);
        }
    }
}